<app-page-meta pageTitle="finzy - Loan Application Status"></app-page-meta>

<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">

      <div class="row finzy-row">
        <div class="divImage">
          <img class="finzy-img" src="{{photo}}">
        </div>
        <p class="finzy-txt-p">{{name}}</p>
        <p class="finzy-txt-loan">{{loanStatus}}</p>
      </div>

      <div class="row finzy-row2" *ngIf="loanprogress == 0">
        <p class="finzy-txt-ps">Keep a watch on this space to see the status of your loan listing.</p>
        <p class="finzy-txt-ps2">We will also reach you on your registered contact details once you are
          funded</p>

        <div class="row finzy-row3">
          <div class="col-sm-4">
            <p class="finzy-p1">₹
              <app-horizontal-loader
                *ngIf="emi_amount === undefined || emi_amount === null"></app-horizontal-loader>
              {{emi_amount | number : fractionSize}}
            </p>
            <p class="finzy-p2">EMI</p>
          </div>
          <div class="col-sm-3 martop">
            <p class="finzy-p1">{{loan_tenure}} </p>
            <p class="finzy-p2">MONTHS</p>
          </div>
          <div class="col-sm-5 martop inline-div perROI">
            <div class="finzy-inline">
              <p class="finzy-p1">
                <app-horizontal-loader
                  *ngIf="emi_amount === undefined || emi_amount === null"></app-horizontal-loader>
                <span *ngIf="emi_amount !== undefined && emi_amount !== null">{{roi}}%</span></p>
            </div>
            <div class="finzy-inline"><p class="finzy-p2">PERSONALISED RATE OF INTEREST</p></div>
          </div>
        </div>

        <div id="progress-bar">
          <div [style.width.%]="loanFilled"></div>
        </div>

        <p class="finzy-txt-ps3"><span class="dark">{{loanFilled}} %</span>&nbsp; of &nbsp;<span
          class="dark">₹ {{loanAmt  | number : fractionSize}} &nbsp;</span>has
          been funded</p>

        <p class="finzy-txt-ps33" *ngIf="investLength>0">Your loan was last funded on {{lastInvested}} </p>
      </div>

      <div class="row mt-4 d-flex justify-content-center" *ngIf="areDocumentsSigned">
        <div
          class="col-xs-12 col-md-9 col-lg-7 background-gray d-flex flex-wrap px-5 py-4 py-sm-5
          align-items-center justify-content-between rounded">
          <div>
            <span class="font-medium font-weight-bold d-block">Signed Documents</span>
            <span>Your signed contract and other documents are available here.</span>
          </div>

          <span class="action-label mt-4 mt-sm-0 font-weight-bold">
            <a [routerLink]="['/borrow/dashboard/loan/' + loanDetails.loan_info._id + '/documents']">View Documents</a>
          </span>
        </div>
      </div>

      <div *ngIf="loanprogress == 100">
        <div class="row finzy-row31">
          <p class="finzy-p82">{{runner}}</p>
          <div class="finzy-row32">
            <ul class="progress_bar">
              <li class='{{activated1}}'><span></span></li>
              <li class='{{activated2}}'><span></span></li>
              <li class='{{activated3}}'><span></span></li>
              <li class='{{activated4}}'></li>
            </ul>
          </div>
          <div class="row finzy-row33">

            <div class="col-sm-3 finzy-responsive-progress"><p class="progresspl {{activated1}}">
              Representative<br>
              scheduled</p></div>
            <div class="col-sm-3 finzy-responsive-progress"><p class="progressp {{activated2}}">Document<br>
              Collected
            </p></div>
            <div class="col-sm-3 finzy-responsive-progress"><p class="progressp {{activated3}}">Document<br>
              Verified
            </p></div>
            <div class="col-sm-3 finzy-responsive-progress"><p class="progresspr {{activated4}}">Loan<br>
              Disbursed</p>
            </div>
          </div>
        </div>

        <div class="row finzy-row34">
          <p class="finzy-p85" *ngIf="emiScheduleLink">To view your EMI schedule <a
            style="text-decoration:none;color:#0d3ab3" [routerLink]="['/borrowerdashboard']">Click
            here</a></p>
        </div>

        <div class="row finzy-row2" *ngIf="!areDocumentsSigned">
          <p class="finzy-p82c">Here are the documents that need completion. finzy is a brand owned by "Bridge
            Fintech Solutions Private Limited” and hence you may see this name on some of the documents you would be
            asked to sign on.</p>
          <p class="downDiv2">Please keep these ready to be picked up.</p>

          <div class="row finzy-row3">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Contract</p>
                  <p class="finzy-p81">Our representative will bring the loan contract agreement, for
                    you to sign. The
                    contract will be between you and the investors who have funded your loan. So you
                    will see their
                    names filled out in the relevant sections. A template of the contract is
                    available for you to
                    download and review</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="{{contract}}" target="_blank" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD & REVIEW</p></a>
              </div>
            </div>
          </div>
          <div class="row finzy-row3">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">NACH</p>
                  <p class="finzy-p81">Our representative will bring a printed NACH mandate form. The
                    NACH mandate helps
                    in easy payment of EMIs. The NACH form will have the amount pre-filled as your
                    loan amount. We will
                    just need your signature at one place. The mandate form is available for your to
                    download and
                    review.</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="{{nach}}" target="_blank" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD & REVIEW</p></a>
              </div>
            </div>
          </div>
          <div class="row finzy-row3">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Demand Promissory Note</p>
                  <p class="finzy-p81">Our representative will bring a Demand Promissory Note (DPN).
                    We will need your
                    signature at one place. The DPN is available for you to download and review.</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="{{dpn}}" target="_blank" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD & REVIEW</p></a>
              </div>
            </div>
          </div>
          <div class="row finzy-row3" *ngIf="partnerDocumentsExist">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Partner Declaration Form</p>
                  <p class="finzy-p81">Our representative will bring a Partner Declaration Form. We
                    will need your
                    signature at one place. This is available for you to download and review.</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="downloadDiv">
                <a href="{{pdform}}" target="_blank" class="downloadanc"><p class="download"><i
                  class="material-icons downloadmat">file_download</i></p>
                  <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD & REVIEW</p></a>
              </div>
            </div>
          </div>
          <div class="row finzy-row3">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                   aria-hidden="true"></i></span></div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Post Dated Cheques</p>
                  <p class="finzy-p81">{{getPostDatedCheckNumberInText()}}
                    post dated cheque(s) (PDCs)
                    need to be handed over to our representative.
                    Please fill the payee as "Bridge FIntech Solutions Private Limited" and leave
                    the date and amount
                    unfilled.</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">

            </div>
          </div>
          <div class="row finzy-row3">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-user-o"
                                                                   aria-hidden="true"></i></span>
                </div>
                <div class="col-sm-10">
                  <p class="finzy-p71">Photograph</p>
                  <p class="finzy-p81">Our representative will click a picture of you for our
                    records</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4">

            </div>
          </div>
        </div>

      </div>

      <div class="row finzy-row4">
        <p class="finzy-p6" *ngIf="finzyDomain">If you need assistance you can find help here <a target="_blank" [routerLink]="['/faq']"
                                                                                                 class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>

    </div>
  </div>
</div>